<template>
  <section class="card">
    <h2 class="section-heading">
      {{ t('employerForm.signature.title') }}
    </h2>

    <div class="form-grid">
      <div class="form_group full-width">
        <label>{{ t('employerForm.signature.signature') }}</label>
        <SignaturePad
          v-model="form.sign"
          :title="t('signature.please_sign_here')"
          class="signature-pad"
        />
        <p class="error-text" v-if="formErrors.has('signature.sign')">
          {{ t(formErrors.first('signature.sign')) }}
        </p>
      </div>

      <div class="form_group">
        <label>{{ t('employerForm.signature.date') }}</label>
        <input
          v-model="form.date"
          type="date" 
          @input="clearError('signature.date')"
          disabled
          class="disabled-input"
        />  
        <p class="error-text" v-if="formErrors.has('signature.date')">
          {{ t(formErrors.first('signature.date')) }}
        </p>
      </div>
    </div>
  </section>
</template>

<script setup>
import { reactive, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import SignaturePad from '@/components/SignaturePad.vue'
import Error from '@/utils/Error'
const { t } = useI18n();

const props = defineProps({
  modelValue: { type: Object, default: () => ({}) },
  formErrors:{
    type:Object,
    required:false,
    default:reactive(new Error({}))
  }
});

const emit = defineEmits(['update:modelValue']);

const today = new Date().toISOString().split('T')[0];
const form = reactive({
  sign: '',
  date: today,
  ...props.modelValue
});
const clearError = async(name)=>{
	emit("removeError",name)
}
watch(form, (v) => {
  emit('update:modelValue', v);
  if (v?.sign) {
    clearError('signature.sign');
  } 
}, { deep: true });

watch(() => props.modelValue, (v) => {
  Object.assign(form, {
    employerName: '',
    signature: '',
    signedAt: '',
    ...v
  });
}, { deep: true, immediate: true });
</script>

<style scoped>
.disabled-input {
  background-color: #f3f4f6;
  cursor: not-allowed;
}
</style>